(function () {
  'use strict';

  var VERSION = '2026-08-18-v11';
  var APP_KEY = 'CS0wMN7hGtPxBSzpvTmm6IvuWBGlgbXyH5OJYZ2x';
  var SITE_REVIEW_ID = 'yotpo_site_reviews';
  var PAGE_SIZE = 5;

  function installInitialPdpHighestRatedRequest() {
    if (window.__nestInitialPdpHighestRatedRequestV3) return;
    if (!/^\/products\//.test(window.location.pathname)) return;
    window.__nestInitialPdpHighestRatedRequestV3 = true;

    var initialRequestRewritten = false;

    function rewrite(url) {
      if (initialRequestRewritten || typeof url !== 'string') return url;

      var parsed;
      try {
        parsed = new URL(url, window.location.href);
      } catch (error) {
        return url;
      }

      var isYotpoProductReviews = /(^|\.)yotpo\.com$/i.test(parsed.hostname) &&
        /\/products\/[^/]+\/reviews\.json$/i.test(parsed.pathname) &&
        parsed.pathname.indexOf('/products/' + SITE_REVIEW_ID + '/') === -1;

      if (!isYotpoProductReviews) return url;

      initialRequestRewritten = true;
      parsed.searchParams.set('sort', 'rating');
      parsed.searchParams.set('direction', 'desc');
      return parsed.toString();
    }

    if (window.fetch) {
      var nativeFetch = window.fetch;
      window.fetch = function (input, init) {
        if (typeof input === 'string') {
          input = rewrite(input);
        } else if (window.Request && input instanceof window.Request) {
          var rewritten = rewrite(input.url);
          if (rewritten !== input.url) input = new Request(rewritten, input);
        }
        return nativeFetch.call(this, input, init);
      };
    }

    if (window.XMLHttpRequest && window.XMLHttpRequest.prototype.open) {
      var nativeOpen = window.XMLHttpRequest.prototype.open;
      window.XMLHttpRequest.prototype.open = function (method, url) {
        var args = Array.prototype.slice.call(arguments);
        args[1] = rewrite(url);
        return nativeOpen.apply(this, args);
      };
    }
  }

  installInitialPdpHighestRatedRequest();

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalize(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function score(review) {
    return Number(review && review.score) || 0;
  }

  function timestamp(review) {
    var parsed = Date.parse(review && review.created_at ? review.created_at : 0);
    return isNaN(parsed) ? 0 : parsed;
  }

  function displayDate(value) {
    var date = new Date(value || 0);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  function customFields(review) {
    var raw = review && review.custom_fields;
    var fields = [];
    if (!raw) return fields;

    if (Array.isArray(raw)) {
      raw.forEach(function (item, index) {
        if (!item) return;
        fields.push({
          label: normalize(item.title || item.name || item.label || ('Detail ' + (index + 1))),
          value: normalize(item.value || item.answer || item.content || '')
        });
      });
      return fields.filter(function (field) { return field.value; });
    }

    Object.keys(raw).forEach(function (key) {
      var item = raw[key];
      var label = key.replace(/^--/, '').replace(/[_-]+/g, ' ');
      var value = item;
      if (item && typeof item === 'object') {
        label = item.title || item.name || item.label || label;
        value = item.value || item.answer || item.content || '';
      }
      value = Array.isArray(value) ? value.join(', ') : value;
      if (normalize(value)) fields.push({ label: normalize(label), value: normalize(value) });
    });
    return fields;
  }

  function fieldMarkup(review) {
    return customFields(review).map(function (field) {
      return '<div class="nest-site-review-field"><strong>' + escapeHtml(field.label) + ':</strong>' +
        '<span>' + escapeHtml(field.value) + '</span></div>';
    }).join('');
  }

  function starMarkup(value) {
    var rounded = Math.max(0, Math.min(5, Math.round(value)));
    var stars = '';
    for (var i = 1; i <= 5; i += 1) {
      stars += '<span aria-hidden="true">' + (i <= rounded ? '&#9733;' : '&#9734;') + '</span>';
    }
    return '<span class="nest-site-review-stars" role="img" aria-label="' + rounded + ' out of 5 stars">' + stars + '</span>';
  }

  var iconInstance = 0;

  function iconMarkup(index) {
    var source = document.getElementById('icon-real-review-' + ((index % 13) + 1));
    if (!source) return '';

    var wrapper = document.createElement('div');
    wrapper.innerHTML = source.innerHTML;
    iconInstance += 1;
    var prefix = 'nest-review-icon-' + iconInstance + '-';
    var idMap = {};

    Array.prototype.forEach.call(wrapper.querySelectorAll('[id]'), function (element) {
      var oldId = element.id;
      var newId = prefix + oldId;
      idMap[oldId] = newId;
      element.id = newId;
    });

    Array.prototype.forEach.call(wrapper.querySelectorAll('*'), function (element) {
      Array.prototype.forEach.call(element.attributes || [], function (attribute) {
        var value = attribute.value;
        Object.keys(idMap).forEach(function (oldId) {
          value = value.split('#' + oldId).join('#' + idMap[oldId]);
        });
        if (attribute.name === 'aria-labelledby' || attribute.name === 'aria-describedby') {
          value = value.split(/\s+/).map(function (token) {
            return idMap[token] || token;
          }).join(' ');
        }
        if (value !== attribute.value) element.setAttribute(attribute.name, value);
      });
    });

    return wrapper.innerHTML;
  }

  function productName(review) {
    var product = review && review.product ? review.product : {};
    return normalize(
      (review && (review.product_title || review.product_name)) ||
      product.name ||
      product.title ||
      ''
    );
  }

  function reviewMarkup(review, index, reviewType) {
    var user = review.user || {};
    var comment = review.comment;
    var name = user.display_name || 'Nest Bedding Customer';
    var reviewId = escapeHtml(review.id || '');
    var reviewedProduct = productName(review);
    var reviewFieldsMarkup = fieldMarkup(review);
    var customerDetailsMarkup = reviewType === 'product' && reviewFieldsMarkup ?
      '<div class="nest-site-review-details">' + reviewFieldsMarkup + '</div>' : '';
    var authorFieldsMarkup = reviewType === 'product' ? '' : reviewFieldsMarkup;
    var cardClass = customerDetailsMarkup ?
      'review-customization nest-site-review-card has-review-details' :
      'review-customization nest-site-review-card';
    var verifiedBuyer = review.verified_buyer === true || review.verified_buyer === 'true';
    var verifiedBuyerMarkup = verifiedBuyer ? '<div class="nest-verified-buyer"><span aria-hidden="true">&#10003;</span>Verified Buyer</div>' : '';
    var commentMarkup = '';

    if (comment && normalize(comment.content)) {
      commentMarkup = '<div class="nest-site-review-reply"><strong>Nest Bedding</strong>' +
        '<p>' + escapeHtml(comment.content) + '</p>' +
        (comment.created_at ? '<time datetime="' + escapeHtml(comment.created_at) + '">' + escapeHtml(displayDate(comment.created_at)) + '</time>' : '') +
        '</div>';
    }

    return '<article class="' + cardClass + '" data-review-id="' + reviewId + '">' +
      '<aside class="nest-site-review-author">' +
        '<div class="bird-image" aria-hidden="true">' + iconMarkup(index) + '</div>' +
        '<h3>' + escapeHtml(name) + '</h3>' + verifiedBuyerMarkup + authorFieldsMarkup +
      '</aside>' + customerDetailsMarkup +
      '<div class="nest-site-review-body">' +
        '<div class="nest-site-review-meta">' + starMarkup(score(review)) +
          '<time datetime="' + escapeHtml(review.created_at || '') + '">' + escapeHtml(displayDate(review.created_at)) + '</time></div>' +
        '<h4>' + escapeHtml(review.title || '') + '</h4>' +
        '<p>' + escapeHtml(review.content || '') + '</p>' +
        (reviewedProduct ? '<p class="nest-site-review-product">Product Reviewed: <strong>' + escapeHtml(reviewedProduct) + '</strong></p>' : '') +
        commentMarkup +
      '</div>' +
    '</article>';
  }

  function reviewText(review) {
    return normalize([
      review.title,
      review.content,
      review.user && review.user.display_name,
      customFields(review).map(function (field) { return field.value; }).join(' ')
    ].join(' ')).toLowerCase();
  }

  function initCustomerReviews(root) {
    if (!root || root.getAttribute('data-nest-review-source') === VERSION) return;
    root.setAttribute('data-nest-review-source', VERSION);

    var grid = root.querySelector('.reviews-grid');
    var moreButton = root.querySelector('.nest-more-reviews');
    var noReviews = root.querySelector('.no-reviews');
    var searchInput = root.querySelector('.free-text-search-input');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-review-type]'));
    var state = {
      reviewType: 'product',
      datasets: { site: null, product: null },
      metadata: { site: null, product: null },
      search: '',
      visible: PAGE_SIZE
    };

    root.classList.add('nest-site-reviews-owned');

    function responseData(payload) {
      return payload && payload.response ? payload.response : (payload || {});
    }

    function responseReviews(payload) {
      var data = responseData(payload);
      if (Array.isArray(data.reviews)) return data.reviews;
      if (Array.isArray(data.results)) return data.results;
      return [];
    }

    function isSiteReview(review) {
      var product = review && review.product ? review.product : {};
      var key = normalize(
        (review && (review.domain_key || review.sku || review.product_id)) ||
        product.domain_key ||
        product.id ||
        ''
      );
      return key === SITE_REVIEW_ID;
    }

    function metadata(payload, reviews) {
      var data = responseData(payload);
      var total = data.pagination && data.pagination.total;
      if (total == null) total = data.total;
      if (total == null) total = reviews.length;
      var average = data.bottomline && data.bottomline.average_score;
      if (average == null && reviews.length) {
        average = reviews.reduce(function (sum, review) { return sum + score(review); }, 0) / reviews.length;
      }
      return { total: total, average: average };
    }

    function setAggregate(meta) {
      var totalNode = root.querySelector('.total-reviews');
      var gradeNode = root.querySelector('.total-grade');
      var starGroup = root.querySelector('[data-aggregate-stars]');
      var stars = root.querySelectorAll('[data-aggregate-star]');
      var rating = meta && meta.average != null ? Math.max(0, Math.min(5, Number(meta.average))) : 0;
      if (totalNode) totalNode.textContent = meta && meta.total != null ? meta.total : '';
      if (gradeNode) gradeNode.textContent = rating ? rating.toFixed(1) : '';
      if (starGroup) starGroup.setAttribute('aria-label', rating ? 'Rated ' + rating.toFixed(1) + ' out of 5 stars' : 'Aggregate rating unavailable');
      Array.prototype.forEach.call(stars, function (star, index) {
        star.style.setProperty('--nest-star-fill', Math.max(0, Math.min(1, rating - index)) * 100 + '%');
      });
    }

    function activeReviews() {
      return state.datasets[state.reviewType] || [];
    }

    function filteredReviews() {
      var reviews = activeReviews().slice();
      if (state.search) {
        reviews = reviews.filter(function (review) {
          return reviewText(review).indexOf(state.search.toLowerCase()) !== -1;
        });
      }
      reviews.sort(function (a, b) {
        return score(b) - score(a) || timestamp(b) - timestamp(a);
      });
      return reviews;
    }

    function render() {
      var reviews = filteredReviews();
      var visible = reviews.slice(0, state.visible);
      grid.innerHTML = visible.map(function (review, index) {
        return reviewMarkup(review, index, state.reviewType);
      }).join('');
      grid.setAttribute('aria-busy', 'false');
      root.classList.remove('is-loading', 'loading');
      if (noReviews) {
        noReviews.textContent = 'There are no reviews';
        noReviews.style.display = visible.length ? 'none' : 'block';
      }
      if (moreButton) moreButton.style.display = reviews.length > state.visible ? '' : 'none';
    }

    function setTabs(type) {
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-review-type') === type;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      grid.setAttribute('aria-labelledby', type === 'site' ? 'nest-site-reviews-tab' : 'nest-product-reviews-tab');
    }

    function fail() {
      grid.innerHTML = '';
      grid.setAttribute('aria-busy', 'false');
      if (noReviews) {
        noReviews.textContent = 'Reviews are temporarily unavailable. Please try again.';
        noReviews.style.display = 'block';
      }
      if (moreButton) moreButton.style.display = 'none';
    }

    function load(type) {
      state.reviewType = type;
      state.visible = PAGE_SIZE;
      setTabs(type);
      if (state.datasets[type]) {
        setAggregate(state.metadata[type]);
        render();
        return;
      }

      grid.innerHTML = '';
      grid.setAttribute('aria-busy', 'true');
      if (noReviews) noReviews.style.display = 'none';
      if (moreButton) moreButton.style.display = 'none';

      var request;
      if (type === 'site') {
        request = fetch('https://api-cdn.yotpo.com/v1/widget/' + APP_KEY + '/products/' + SITE_REVIEW_ID + '/reviews.json?per_page=150&page=1&sort=rating&direction=desc', {
          headers: { Accept: 'application/json' }
        });
      } else {
        request = fetch('https://api-cdn.yotpo.com/v1/reviews/' + APP_KEY + '/filter.json?page=1&per_page=150', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ per_page: 150 })
        });
      }

      request
        .then(function (response) {
          if (!response.ok) throw new Error('Reviews request failed');
          return response.json();
        })
        .then(function (payload) {
          var reviews = responseReviews(payload);
          if (type === 'product') reviews = reviews.filter(function (review) { return !isSiteReview(review); });
          state.datasets[type] = reviews;
          state.metadata[type] = metadata(payload, reviews);
          setAggregate(state.metadata[type]);
          render();
        })
        .catch(fail);
    }

    root.addEventListener('click', function (event) {
      var control = event.target.closest('[data-review-type], .clear-text-icon, .nest-more-reviews');
      if (!control) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      if (control.hasAttribute('data-review-type')) {
        load(control.getAttribute('data-review-type'));
        return;
      }

      if (control.matches('.clear-text-icon')) {
        state.search = '';
        if (searchInput) searchInput.value = '';
        render();
      }

      if (control.matches('.nest-more-reviews')) {
        state.visible += PAGE_SIZE;
        render();
      }

    }, true);

    root.addEventListener('keydown', function (event) {
      var current = event.target.closest('[data-review-type]');
      if (!current || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
      event.preventDefault();
      var index = tabs.indexOf(current);
      var next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;
      tabs[next].focus();
      tabs[next].click();
    });

    var searchTimer = null;
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(function () {
          state.search = normalize(searchInput.value);
          state.visible = PAGE_SIZE;
          render();
        }, 180);
      }, true);
    }

    load('product');
  }

  function init() {
    var root = document.querySelector('.nest-customer-reviews[data-review-surface="customer-reviews"]');
    if (root) initCustomerReviews(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(init, 500);
    }, { once: true });
  } else {
    window.setTimeout(init, 500);
  }
})();
